import React from "react";
import PropTypes from "prop-types";

const CheckboxItem = ({ id, label, name, value, checked = false, onChange = undefined }) => (
	<div className="filters__checkbox-row">
		<input
			id={id}
			name={name}
			value={value}
			type="checkbox"
			className="filters__checkbox-input"
			checked={checked}
			onChange={onChange}
		/>
		<label
			className="filters__checkbox-label"
			htmlFor={id}
		>
			{label}
		</label>
	</div>
);

CheckboxItem.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	checked: PropTypes.bool,
	onChange: PropTypes.func
};

export default CheckboxItem;
